import { get } from 'lodash';
import { sortMetricsByOrder } from './metricsOrder';

/**
 * @param {array} args Total list of filter objects
 */
const parseCompareTotals = (args = []) => {
  const coreMetrics = Object.keys(get(args[0], '[0].totals') || {});

  const metrics = sortMetricsByOrder(coreMetrics);

  const totalObj = metrics.reduce((obj, metric) => ({ ...obj, [metric]: [] }), {});

  args.forEach((arg) => {
    const totals = get(arg, '[0].totals') || {};
    metrics.forEach((metric) => {
      totalObj[metric].push(totals[metric]);
    });
  });

  return totalObj;
};

export default parseCompareTotals;
